/**
 * Phase 6e.4.2-hotfix-2 — soft-delete is gone (Bug D).
 *
 * The Phase 6a.22a `isContractDeleted` / `deletedContractIndices` /
 * `findAdjacentLiveContractIndex` helpers exercised a parallel
 * `contractDeletions` map that is no longer part of
 * `EngagementHistoryEntry`. After hard delete, the contracts array IS
 * the list of live slots, so the "find the next live slot" walk
 * collapses to a trivial ±1 step within bounds.
 *
 * This file is kept as the home for future per-contract deletion
 * helpers; right now it exports just the bounds-checking step helper.
 */

/**
 * Step ±1 from `fromIdx` and return the candidate index, or `null` if
 * the step would go out of `[0, contractCount)`. Used by the Prev /
 * Next buttons in `ContractEntryPage` and `EngagementHeader`.
 */
export function findAdjacentContractIndex(
  contractCount: number,
  fromIdx: number,
  direction: "prev" | "next",
): number | null {
  const step = direction === "next" ? 1 : -1;
  const candidate = fromIdx + step;
  if (candidate < 0 || candidate >= contractCount) return null;
  return candidate;
}
